/* eslint-disable react/require-default-props, jsx-a11y/control-has-associated-label, jsx-a11y/anchor-is-valid, react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Message from '../../img/message.png';
import styles from '../../styles/modals/info.module.css';

const propTypes = {
    className: PropTypes.string,
};

const InfoModal = ({ className = null }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        <p className={styles.description}>
            Pour 2025, URBANIA vous propose de repartir à neuf et de laisser tout ce qui vous a fait
            $@?$ dans les cendres du passé.
        </p>
        <p className={styles.description}>
            Passez au feu tout ce qui vous a fait sacrer (et plus encore) cette année.
        </p>
        <p className={styles.description}>
            On vous a préparé une petite sélection de notre cru, mais sentez-vous libre de
            téléverser vos pires démons pour les voir brûler (muahaha) – c’est votre moment.
        </p>
        <p className={styles.description}>
            Partagez l’expérience à vos collègues qui ne l’ont pas eu facile cette année, ils-elles
            le méritent.
        </p>
        <p className={styles.description}>
            Vous verrez qu’à la gang, le feu brûle encore plus fort, et c’est encore plus beau.
        </p>
        <p className={styles.description}>
            De la part de toute l’équipe d’URBANIA, on vous souhaite un temps des fêtes léger et
            agréable, et on vous dit à l’année prochaine.
        </p>
        <img src={Message} alt="Message" className={styles.message} />
    </div>
);

InfoModal.propTypes = propTypes;

export default InfoModal;
